import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY


export const getContacts = async () => {
    try {
        const result = await api.get(`${urlApi}/talentoHumano/getContacts`);
        return result.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
}

export const getUsersContact = async () => {
    try {
        const result = await api.get(`${urlApi}/talentoHumano/getUserContacts`);
        return result.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
}

export const addContact = async (contact) => {
    try {
        const result = await api.post(`${urlApi}/talentoHumano/addContact/${contact}`);
        return result.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
}

export const updateContact = async (contact, action) => {
    try {
        const result = await api.post(`${urlApi}/talentoHumano/updateContact/${contact}/${action}`);
        return result.data;
    } catch (error) {
        console.log("error", error);
        throw error;
    }
}
